import { FormRow, FormSection, MediumFormRow } from 'framework/ui/layout';
import PrepopulationWrapper from 'domain/people/employee/prepopulation/PrepopulationWrapper';
import CopyableEmployeeAddressInput from 'domain/people/employee/shared/input/CopyableEmployeeAddressInput';
import CopyableLocationInput from 'domain/people/employee/shared/input/CopyableLocationInput';
import LocationUpdateDateInput from 'domain/people/employee/shared/input/LocationUpdateDateInput';
import { AdditionalContactListInput } from 'domain/shared/contact';
import { forwardRef } from 'react';
import { PhoneInput, TextInput } from 'framework/form';

type ContactInfoUpdateSectionProps = {
  isGrantedUpdateContactInfo: boolean;
};

const ContactInfoUpdateSection = forwardRef<HTMLSpanElement, ContactInfoUpdateSectionProps>(
  ({ isGrantedUpdateContactInfo }, ref) => {
    return (
      <FormSection title="Contact information" isVisible={isGrantedUpdateContactInfo}>
        <FormRow>
          <PhoneInput source="extendedInformation.personalPhoneNumber" />
          <TextInput source="extendedInformation.personalEmail" label="Personal Email Address" />
          <PhoneInput source="extendedInformation.otherPhoneNumber" />
        </FormRow>

        <AdditionalContactListInput source="extendedInformation.additionalContactInfo" />

        <span ref={ref} className="invisible-anchor" />
        <MediumFormRow>
          <PrepopulationWrapper>
            <CopyableEmployeeAddressInput
              source="extendedInformation.homeAddress"
              copySource="extendedInformation.registrationAddress"
              label="Current location address"
              buttonText="Same as registration address"
            />
          </PrepopulationWrapper>
          <CopyableEmployeeAddressInput
            source="extendedInformation.registrationAddress"
            copySource="extendedInformation.homeAddress"
            label="Registration address"
            buttonText="Same as current location address"
          />
        </MediumFormRow>
        <MediumFormRow>
          <CopyableLocationInput
            source="extendedInformation.plannedMidTermLocation"
            copySource="extendedInformation.homeAddress"
            label="Planned mid-term location"
            buttonText="Same as current location address"
            tooltipMessage="Planned location for the nearest month"
          />
          <CopyableLocationInput
            source="extendedInformation.plannedPermLocation"
            copySource="extendedInformation.homeAddress"
            label="Planned permanent location"
            buttonText="Same as current location address"
            tooltipMessage="Planned location for the nearest year"
          />
        </MediumFormRow>
        <MediumFormRow>
          <LocationUpdateDateInput source="extendedInformation.locationUpdateDate" label="Date of location update" />
        </MediumFormRow>
      </FormSection>
    );
  },
);

export { ContactInfoUpdateSection };
